<template>
  <div container class="payment-inquiry ">
<!--    <form method="POST">-->
      <div  class=" mt-4 ">
        <!-- Client Name / Agency Info -->
        <div grid="row wrap" >
          <div column="xs-12 l-12"><h2 class="grape text-captialize _pl0">Inquiry on Commissions Payments</h2></div>
          <div column="xs-12 m-7">
            <app-input
              label="Client Name:"
              v-model="$v.inquiry.clientName.$model"
              :error-message="clientNameError"
              :invalid="$v.inquiry.clientName.$invalid"
              :required="true"
              modifier=""
            />
          </div>
          <div column="xs-12 m-5">
            <span class="flex-row">
              <label>Date Range for missing payment</label>
              <validation-message :required="true" :invalid="$v.inquiry.dateRangeStart.$invalid || $v.inquiry.dateRangeEnd.$invalid" :errorMessage="dateRangeError"/>
            </span>
            <date-range-picker
              class="_mrs date-range-picker width90"
              ref="picker"
              :opens="opens"
              :locale-data="locale"
              :ranges="ranges"
              :showWeekNumbers="false"
              :showDropdowns="true"
              :autoApply="true"
              v-model="dateRange"
              @update="updateDateRange()"
              :linkedCalendars="false"
              :dateFormat="dateFormat"
              :closeOnEsc="true"
            >
              <template v-slot:input="picker" class="datePickerRange">
                <label class="width90"
                >{{ selectedDates }}
                  <font-awesome-icon
                    class="_mlxs"
                    icon="xmark"
                    aria-label="clear selection"
                    v-if="dateRange.endDate"
                    @click.stop="clearSelectedDates()"
                  />
                </label>
              </template>
            </date-range-picker>
          </div>
        </div>
        <div class="info-box" grid="row wrap" >
            <div column="xs-12 l-7">
              <app-input
              label="Subgroup"
              v-model="$v.inquiry.subgroup.$model"
              :error-message="subgroupError"
              :invalid="$v.inquiry.subgroup.$invalid"
              :required="true"
              modifier=""
              />
            </div>
          <div column="xs-12 l-5">
              <app-input
              label="Disbursement Id:"
              v-model="$v.inquiry.disbursementId.$model"
              :error-message="disbursementIdError"
              :invalid="$v.inquiry.disbursementId.$invalid"
              :required="true"
              modifier=""
              />
            </div>
        </div>

        <!-- Agency Location -->
      <div class="info-box"  grid="row wrap">
        <div column="xs-12 m-8 l-8">
          <app-input v-model="$v.inquiry.agencyName.$model" id="agencyNameInput" label="Agency Name:" :error-message="agencyNameError"
                     :invalid="$v.inquiry.agencyName.$invalid" :required="true"></app-input>
        </div>

        <div column="xs-12 m-4 l-4">
          <app-input v-model="$v.inquiry.agencyTaxId.$model" id="agencyTaxIdInput" label="Agency Tax Id:" :error-message="taxIdError"
                     :invalid="$v.inquiry.agencyTaxId.$invalid" :required="true"></app-input>
        </div>
        <div column="xs-12 m-12 l-12">
          <app-input v-model="$v.inquiry.agencyAddress.$model" :error-message="agencyAddressError"
                     :invalid="$v.inquiry.agencyAddress.$invalid" :required="true" label="Agency Address:"></app-input>
        </div>
<!--        <div column="xs-12 m-4 l-4"></div>-->
      </div>

      <div class="info-box"  grid="row wrap">
        <div column="xs-12 m-12">
          <app-input v-model="$v.inquiry.description.$model" type="textarea" label="Description:" :error-message="descriptionError"
                     :invalid="$v.inquiry.description.$invalid" :required="true"></app-input>
        </div>
      </div>
        <div class="info-box" grid="row wrap" >
          <div class="flex-column" column="xs-12 l-12">
          <span class="flex-column">
            <span class="flex-row">
              <label>Attachments:</label>
              <validation-message :invalid="$v.attachments.$invalid || failedFiles.length > 0" :errorMessage="attachmentsError"/>
            </span>
            <vue-dropzone
              id="dropzone"
              :key="dropZoneKey"
              ref="myVueDropzone"
              tabindex="0"
              class="_mbm"
              :options="dropzoneOptions"
              :use-custom-slot="true"
              duplicate-check
              @keydown.stop.native.enter="manuallyOpenDropzone"
              @vdropzone-thumbnail="thumbnail"
              @vdropzone-files-added="checkFiles"
              @vdropzone-removed-file="checkFiles"
            >
              <p>
                {{ value.fileUploader.label }} <br /><strong>{{
                  value.fileUploader.validationMessage
                }}</strong>
              </p>
            </vue-dropzone>
          </span>
          </div>
        </div>

        <div grid="row wrap" class="button-panel">
        <button type="cancel" class="grape white _mtxs --sm" @click="$router.go(-1)">Cancel</button>
        <async-button  class="grape _mtxs --sm" @clicked="submitPaymentInquiry()" :executing="submissionLoading"
                      :disabled="this.$v.$invalid || this.failedFiles.length > 0" >
          <template #buttonContent>
            <span>Submit Payment Inquiry</span>
          </template>
        </async-button>
      </div>
      </div>
<!--    </form>-->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import formattable from '@mixins/formattable'
import cloudCannonable from '@mixins/CloudCannonable'
import dragdrop from '@mixins/dragdrop'
import AppPlaceholderInput from '@atoms/PlaceholderInput'
import AsyncLoader from '@molecules/AsyncLoader'
import tableSorter from '@mixins/tableSorter'
import AppAdvancedTable from '@organisms/AdvancedTable'
import ColumnPicker from '@molecules/ColumnPicker'
import DateInput from '@atoms/DateInput'
import Select from '@atoms/Select'
import AppInput from '@atoms/Input'
import ValidationMessage from '@atoms/ValidationMessage'
import AsyncButton from '@molecules/AsyncButton.vue'
import {addressFromAgency, nineDigits, taxIdEinOrSsn} from '@utils';
import DateRangePicker from 'vue2-daterange-picker';
const {dateFormat} = require("vue2-daterange-picker/src/components/dateformat");
import { statesList } from '@js/us-states'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import vue2Dropzone from 'vue2-dropzone'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import * as serviceDeskActionTypes from "@store/modules/serviceDesk/actionTypes";
import * as authActionTypes from "@store/modules/auth/actionTypes";
import {alphaNum, maxLength, minLength, numeric, required} from "vuelidate/lib/validators";
import moment from "moment";

export default {
  name: 'PaymentInquiry',
  mixins: [tableSorter, formattable, cloudCannonable, dragdrop],
  components: {
    AppPlaceholderInput,
    FontAwesomeIcon,
    AsyncLoader,
    AppAdvancedTable,
    ColumnPicker,
    DateInput,
    AppInput,
    AsyncButton,
    Select,
    ValidationMessage,
    DateRangePicker,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      locationOptions: [{}],
      contactOptions: [{}],
      yesNoOptions: [
        { value: 'Y', text: 'Yes' },
        { value: 'N', text: 'No' }
      ],
      dateRange: {
        // used for v-model prop
        startDate: null,
        endDate: null,
      },
      opens: 'center', //which way the picker opens, default "center", can be "left"/"right"
      autoApply: 'true',
      locale: {
        direction: 'ltr', //direction of text
        format: 'DD-MM-YYYY', //fomart of the dates displayed
        separator: ' - ', //separator between the two ranges
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: moment.weekdaysMin(), //array of days - see moment documenations for details
        monthNames: moment.monthsShort(), //array of month names - see moment documenations for details
        firstDay: 1, //ISO first day of week - see moment documenations for details
        showWeekNumbers: true, //show week numbers on each row of the calendar
      },
      ranges: false,
      statesListOptions:[],
      inquiry: {
        clientName: '',
        disbursementId: '',
        subgroup: '',
        dateRangeStart: '',
        dateRangeEnd: '',
        agencyName: '',
        agencyTaxId: '',
        agencyAddress: '',
        description: '',
      },
      attachments: '',
    }
  },
  methods: {
    async updateAttachments() {
      this.$v.attachments.$model =  await this.$refs.myVueDropzone.getAcceptedFiles()
    },
    updateDateRange() {
      this.$v.inquiry.dateRangeStart.$model = this.formatDate(this.dateRange.startDate, 'MM/DD/YYYY')
      this.$v.inquiry.dateRangeEnd.$model = this.formatDate(this.dateRange.endDate, 'MM/DD/YYYY')
    },
    clearSelectedDates() {
      this.dateRange.startDate = null;
      this.dateRange.endDate = null;
      this.$v.inquiry.dateRangeStart.$model = ''
      this.$v.inquiry.dateRangeEnd.$model = ''
    },

    async submitPaymentInquiry(record){
      const redirect = () => this.$router.go(-1)
      this.$store.dispatch(serviceDeskActionTypes.SUBMIT_PAYMENT_INQUIRY, { body: this.inquiry, attachments: this.attachments, redirect } )
    },
  },
  computed: {
    ...mapGetters([
      'brokerPersonalInfo',
      'brokerPersonalInfoLoading',
      'submissionLoading',
      'contactType', 'minimumAccess'
    ]),
    selectedDates() {
      return this.dateRange.endDate
        ? moment(this.dateRange.startDate).format('MM/DD/YYYY') +
        '-' +
        moment(this.dateRange.endDate).format('MM/DD/YYYY')
        : 'Select Date Range';
    },
    attachmentsError() {
      if(this.failedFiles.length > 0){
        return 'Remove failed upload(s)'
      } else if (!this.$v.attachments.maxLength) {
        return '5 file max'
      }
      return null
    },
    clientNameError() {
      if (!this.$v.inquiry.clientName.required) {
        return 'required';
      } else if (!this.$v.inquiry.clientName.maxLength) {
        return '255 character max';
      }
      return null;
    },
    subgroupError() {
      if (!this.$v.inquiry.subgroup.maxLength) {
        return '500 character max';
      }
      return null;
    },
    disbursementIdError() {
      if (!this.$v.inquiry.disbursementId.maxLength) {
        return '20 character max';
      }
      return null;
    },
    dateRangeError() {
      // if (!this.$v.inquiry.dateRange.startDate.required || !this.$v.inquiry.dateRange.endDate.required) {
      //   return 'required';
      // }
      if (!this.$v.inquiry.dateRangeStart.required || !this.$v.inquiry.dateRangeEnd.required) {
        return 'required';
      }
      return null;
    },

    agencyNameError(){
      if (!this.$v.inquiry.agencyName.required) {
        return 'Required';
      } else if (!this.$v.inquiry.agencyName.maxLength) {
        return '255 character max';
      }
      return null;
    },

    agencyAddressError(){
      if (!this.$v.inquiry.agencyAddress.required) {
        return 'Required';
      } else if (!this.$v.inquiry.agencyAddress.maxLength) {
        return '255 character max';
      }
      return null;
    },
    descriptionError(){
      if (!this.$v.inquiry.description.required) {
        return 'Required';
      } else if (!this.$v.inquiry.description.maxLength) {
        return '2000 character max';
      }
      return null;
    },
    taxIdError(){
      if (!this.$v.inquiry.agencyTaxId.required) {
        return 'Required';
      }  else if (!this.$v.inquiry.agencyTaxId.taxIdEinOrSsn) {
        return 'bad format';
      }
      return null;
    },
  },
  beforeMount(){
    if (this.contactType === 'WRITING_BROKER' ||this.contactType !== 'WRITING_BROKER' && !this.minimumAccess.commissionAllowed ) {
      const redirect = () => this.$router.go(-1)
      this.$store.dispatch(authActionTypes.SUBMIT_PAYMENT_INQUIRY_UNAUTHORIZED, { redirect } )
    }else {
      this.dropzoneCallback = this.updateAttachments
      for (const stateCode in statesList) {
        this.statesListOptions.push({text: statesList[stateCode], value: stateCode})
      }
    }
  },

  validations: {
    attachments: {},
    inquiry: {
      clientName: {
        required,
        maxLength: maxLength(255),
      },
      subgroup: {
        maxLength: maxLength(1000),
      },
      disbursementId: {
        maxLength: maxLength(32)
      },
      dateRangeStart: {
        required
      },
      dateRangeEnd: {
        required
      },
      dateRange: {
        // required,
        startDate: {
          // required
        },
        endDate: {
          // required
        }
      },
      agencyTaxId: {
        required,
        taxIdEinOrSsn,
      },
      agencyName: {
        required,
        maxLength: maxLength(255)
      },
      agencyAddress: {
        required,
        maxLength: maxLength(255)
      },
      description: {
        required,
        maxLength: maxLength(2000)
      },
    },
  },
}
</script>
<style lang="scss" scoped>
.all-clients {
  .text-captialize {
    font-size: 1.75rem;
    line-height: 1;
    color: #2b2c2e;
    text-transform: capitalize;
  }
}
span.validation {
  display: flex;
  align-items: center;
  margin-left: .3em;
}
.width90 {
  width: 90%;
}
</style>
